export const paths = {
  homeValuation: (page?: string) => `/home-valuation/${page || 'property-valuation'}`,
  homeValuationSummary: (id: string) => `/home-valuation-summary/${id}`,
}
